<template>
  <div v-if="open" class="filter-drawer-root">
    <div
      class="filter-drawer-backdrop"
      aria-hidden="true"
      @click="closeDrawer"
    />

    <aside
      class="filter-drawer-panel"
      role="dialog"
      :aria-label="$l('filters')"
    >
      <div class="drawer-inner">
        <div class="drawer-header">
          <span class="drawer-title">{{ $l('filters') }}</span>
          <button
            type="button"
            class="drawer-close-btn tw-pressable"
            aria-label="Close"
            @click="closeDrawer"
          >
            <outline-icon name="x" />
          </button>
        </div>

        <div class="drawer-body">
          <price-scroll-indicator
            v-if="products.length"
            :sticky="false"
            :scroll-spy="false"
            :products="products"
            :price-bounds="priceBounds"
            :currency-sign="currencySign"
            :hide-accessories="value.hideAccessories === true"
            :search-query="searchQuery"
            @bar-click="onBracket"
          />

          <filter-sidebar
            :value="value"
            :price-bounds="priceBounds"
            :products="products"
            :currency-sign="currencySign"
            :search-query="searchQuery"
            hide-price-histogram
            @input="onSidebarInput"
            @scroll-to-price-bracket="onBracket"
          />
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import OutlineIcon from './OutlineIcon.vue';
import FilterSidebar from './FilterSidebar.vue';
import PriceScrollIndicator from './PriceScrollIndicator.vue';

export default {
  name: 'FilterDrawer',
  components: {
    OutlineIcon,
    FilterSidebar,
    PriceScrollIndicator,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    priceBounds: {
      type: Object,
      default: () => ({ min: 0, max: 1000 }),
    },
    products: {
      type: Array,
      default: () => [],
    },
    currencySign: {
      type: String,
      default: '$',
    },
    searchQuery: {
      type: String,
      default: '',
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        document.body.style.overflow = val ? 'hidden' : '';
      },
    },
  },
  destroyed() {
    document.body.style.overflow = '';
  },
  methods: {
    closeDrawer() {
      this.$emit('close');
    },
    onSidebarInput(filters) {
      this.$emit('input', filters);
      this.closeDrawer();
    },
    onBracket(event) {
      this.closeDrawer();
      this.$nextTick(() => {
        this.$emit('scroll-to-price-bracket', event);
      });
    },
  },
};
</script>

<style scoped>
.filter-drawer-root {
  position: fixed;
  inset: 0;
  z-index: 1060;
}

.filter-drawer-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  animation: backdrop-in 0.25s ease;
}

.filter-drawer-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  width: min(85vw, 320px);
  background: #fff;
  display: flex;
  flex-direction: column;
  animation: panel-in 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.filter-drawer-panel {
  left: 0;
  box-shadow: 8px 0 32px rgba(15, 23, 42, 0.15);
}

[dir='rtl'] .filter-drawer-panel {
  left: auto;
  right: 0;
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.15);
}

[dir='rtl'] .filter-drawer-panel {
  animation-name: panel-in-rtl;
}

.drawer-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.drawer-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

@keyframes backdrop-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes panel-in {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

@keyframes panel-in-rtl {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>
